<template>
  <div class="app-container" @click="showHospitalPickerByKeyword = false">
    <td>
      <img class :src="(examType === 'pre' || examType === '') && preCoverUrl ? preCoverUrl : (examType === 'beh' && behCoverUrl) ?  behCoverUrl : defaultCoverUrl" style="width:100%;display:block" />
      <!-- <img
        class
        src="../../assets/images/logo.png"
        style="width: 23%;position: absolute;top: -12px;left: 11px;z-index: 2;"
      /> -->
    </td>
    <!-- <img class="banner" src="../../assets/images/banner.png" /> -->
    <div>
      <div class="news-detail">
        <div class="title" v-html="meetingName.replace(/\n|\r\n/g, '<br>')"></div>
        <div class="examType">{{ examType === 'beh' ? '会后调研' : '会前调研' }}</div>
        <div class="content" v-html="examType === 'beh' ? behRemark : preRemark"></div>
      </div>
      <div >
        <div class="container" style="position:relative">
          <van-field
                  v-model="ruleForm.name"
                  label="姓名"
                  placeholder="请输入姓名"
                  input-align="right"
                  :rules="[{ required: true }]"
          >
            <div slot="left-icon"><van-icon :name="image_name" /></div>
          </van-field>
        </div>
        <div  class="container" style="position:relative">
          <van-field
              readonly
              clickable
              :value="ruleForm.address"
              label="省市"
              placeholder="请选择省市"
              input-align="right"
              right-icon="arrow"
              :rules="[{ required: true }]"
              @click="showProvincePicker = true"
          >
            <div slot="left-icon"><van-icon :name="image_address" /></div>
          </van-field>
        </div>
        <div class="container" style="position:relative">
          <van-popup v-model="showProvincePicker" position="bottom">
            <van-area
                title="医院"
                :area-list="areaList"
                :columns-num="2"
                @confirm="getProvince"
                @cancel="showProvincePicker = false"
            />
          </van-popup>
        </div>
        <div class="container" style="position:relative">
          <van-field
              v-model="ruleForm.remark"
              label="医院"
              placeholder="请输入医院"
              input-align="right"
              @input="queryHospitalAccordingTokeyword"
              @click="queryHospitalAccordingTokeyword(ruleForm.remark)"
              :rules="[{ required: true }]"
          >
            <div slot="left-icon"><van-icon :name="image_hospital" /></div>
          </van-field>
        </div>

        <div
            v-if="showHospitalPickerByKeyword"
            class="hospitalListByKeyword"
            style="position: absolute;z-index: 200;max-height: 200px;overflow-y: scroll;"
        >
          <van-cell
              style="background-color: #eee;"
              icon="hotel-o"
              v-for="(item, index) in hospitalListByKeyword"
              :key="index"
              :value="item"
              @click="getHospitalByKeyword(item)"
          >
            <template #right-icon>
              <van-icon name="search" class="search-icon" style="margin-top: 5px;" />
            </template>
          </van-cell>
        </div>
        <div v-if="!isEmployee" class="container" style="position:relative">
          <van-field
              readonly
              clickable
              :value="ruleForm.department"
              label="科室"
              placeholder="请选择科室"
              input-align="right"
              right-icon="arrow"
              :rules="[{ required: true }]"
              @click="showDepartmentPicker = true"
          >
            <div slot="left-icon"><van-icon :name="image_department" /></div>
          </van-field>
        </div>
        <van-popup v-model="showDepartmentPicker" position="bottom">
          <van-picker
              show-toolbar
              :columns="departmentList"
              value-key="value"
              @confirm="getDepartment"
              @cancel="showDepartmentPicker = false"
          />
        </van-popup>
<!--        <div v-if="needFillForm" class="container" style="margin-top:0px;text-align:center;background:#fff">-->
<!--          <van-button   color="#8259E1"  block class="button"  @click="getExamByDepartment()">确定</van-button>-->
<!--        </div>-->
      </div>
      <div class="container" style="position:relative" v-show="isSign==0">
          <van-field
                  v-model="ruleForm.phone"
                  label="手机号"
                  type="number"
                  :border="false"
                  placeholder="请输入手机号"
                  input-align="right"
                  :rules="[{ required: true }]"
          >
            <div slot="left-icon"><van-icon :name="image_phone" /></div>
          </van-field>
          <!-- <van-button v-show="show" type="info" @click="sendVcode" size="mini" class="phone-btn">发送验证码</van-button>
          <van-button v-show="!show" disabled  type="info" @click="sendVcode" size="mini" class="phone-btn">{{count}} s</van-button> -->
          <!-- <van-tag v-show="show" type="primary" @click="sendVcode" size="medium" class="phone-btn">发送验证码</van-tag>
          <van-tag v-show="!show" disabled type="primary" size="medium" class="phone-btn">{{count}} s</van-tag> -->
        </div>

        <div class="container" style="position:relative" v-show="isSign==0">
          <van-field
                  v-model="ruleForm.vcode"
                  label="验证码"
                  type="number"
                  placeholder="请输入验证码"
                  input-align="right"
                  :rules="[{ required: true }]"
          >
            <div slot="left-icon"><van-icon :name="image_vcode" /></div>
            <template #button>
              <van-tag v-show="show" type="primary" @click="sendVcode" size="medium" class="phone-btn">发送验证码</van-tag>
              <van-tag v-show="!show" disabled type="primary" size="medium" class="phone-btn">{{count}} s</van-tag>
            </template>
          </van-field>
        </div>
      <div v-if="!isQuest && !ruleForm.department " align="center" style="margin-top: 30px;">
        请选择科室显示对应问卷
      </div>
      <van-cell-group v-for="(item, index) in questions" :key="index" class="cell-group">
        <div class="question"><span>{{index + 1}}.</span><span v-html="item.question.replace(/\n|\r\n/g, '<br>')"></span>
        <span v-if="item.type === 'RADIO'">(单选)</span>
        <span v-if="item.type === 'CHECKBOX'">(多选)</span>
        </div>
        <van-radio-group v-if="item.type === 'RADIO'" v-model="item.answer">
          <div v-for="(option, index) in JSON.parse(item.options)" :key="index">
            <van-radio :name="option.seq">{{option.seq}}<strong>.</strong>&nbsp;{{ option.value }}</van-radio>
            <van-field v-if="option.value === '其他'" v-model="item.otherAnswer" placeholder="请输入内容" value="" maxlength=100 style="background-color: #f7f7f7"/>
            <van-field v-if="option.value.indexOf('原因是')>-1" v-model="item.reason" placeholder="请输入内容" value="" maxlength=100 style="background-color: #f7f7f7"/>
            <van-field v-if="option.value.indexOf('工具为')>-1" v-model="item.tools" placeholder="请输入内容" value="" maxlength=100 style="background-color: #f7f7f7"/>
          </div>
        </van-radio-group>
        <van-checkbox-group v-if="item.type === 'CHECKBOX'" v-model="item.answer">
          <div v-for="(option, index) in JSON.parse(item.options)" :key="index">
            <van-checkbox shape="square" :name="option.seq">{{option.seq}}<strong>.</strong>&nbsp;{{ option.value }}</van-checkbox>
            <van-field v-if="option.value === '其他'" v-model="item.otherAnswer" placeholder="请输入内容" value="" maxlength=100 style="background-color: #f7f7f7"/>
          </div>
        </van-checkbox-group>
        <van-field v-if="item.type === 'TEXT'" rows="3" autosize type="textarea" v-model="item.answer" value=""/>
      </van-cell-group>
    </div>
    <div style="margin-top:20px;text-align:center;background:#fff" v-if="isQuest">
      <van-button  @click="handleSubmit()" block class="button" color="#8259E1">提交</van-button>
    </div>
    </div>
</template>
<script>
import API from '@/api/common';
import wx from 'weixin-js-sdk'
import image_name from "@/assets/images/name.png";
import image_phone from "@/assets/images/phone.png";
import image_vcode from "@/assets/images/vcode.png";
import image_address from "@/assets/images/addicon.png";
import image_hospital from "@/assets/images/hospital.png";
import image_department from "@/assets/images/department.png";
import {areaList} from "@vant/area-data";
export default {
  name: "exam",
  data() {
    return {
      ruleForm: {
        name: "", // 姓名
        phone: "",
        vcode: "",
        province: "", // 省
        city: "", // 市
        hospital: "", // 医院
        address: "",
        remark: "", //其他医院
        openid: this.$route.query.openid,
        department: this.$route.query.department,
        meetingId: this.$route.query.meetingId,
        meetingType: this.$route.query.meetingType,
        examId: this.$route.query.examId,
        unionid: this.$route.query.unionid,
      }, // 表单内容
      show:true,
      isSign: this.$route.query.isSign,
      needFillForm: true,
      departmentList: [],
      hospitalList: [],
      hospitalListByKeyword: [],
      cityListAll: [],
      areaJson: "",
      areaList: areaList,
      isEmployee: false,
      showProvincePicker: false,
      showHospitalPicker: false,
      showDepartmentPicker: false,
      hospitalInputIsShow: false,
      showHospitalPickerByKeyword: false,
      hospitalRequired: false,
      image_name: image_name,
      image_vcode: image_vcode,
      image_address: image_address,
      image_hospital: image_hospital,
      image_department: image_department,
      image_phone:image_phone,
      preCoverUrl: '',
      behCoverUrl: '',
      defaultCoverUrl: require('../../assets/images/top.jpg'),
      meetingName: '',
      openid: this.$route.query.openid,
      meetingId: this.$route.query.meetingId,
      examId: this.$route.query.examId,
      examType: this.$route.query.examType,
      area: this.$route.query.area,
      tbGroup: this.$route.query.tbGroup == 'CMA+FG'?'CMA': this.$route.query.tbGroup,
      examName: this.$route.query.examName, //
      questions: [],
      isQuest: false,
      preRemark: '',
      behRemark: ''
    }
  },
  created() {
    this.resertInfo()
    this.getDepartmentList();
    this.getMeeting(this.ruleForm.meetingId)
    if (this.ruleForm.meetingType == 1 && this.ruleForm.examId && this.ruleForm.examId !== 'null') {
      this.showExam = true
      this.findExam(this.ruleForm.examId)
    }
    this.getExamByDepartment();
    this.init();
  },
  methods: {
    sendVcode() {
      if(!this.ruleForm.phone){
        this.$message.error("请输入手机号!");
        return
      }
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
      }
      API.sendVcode(this.ruleForm.phone).then((data) => {
        this.$message.success("发送成功!");
      });
    },
    resertInfo(){
      API.getCustomerInfo(this.openid).then(result1 => {
        if(result1.data){
          this.ruleForm.name = result1.data.tbName
          this.ruleForm.department = result1.data.department
          this.ruleForm.remark = result1.data.hosName
          if (result1.data.province && result1.data.city) {
            this.ruleForm.address = result1.data.province+"-"+result1.data.city
          }
          this.ruleForm.province = result1.data.province
          this.ruleForm.city = result1.data.city
          this.needFillForm = false
        }
      })
    },
    getExamByDepartment(){
      // alert(this.meetingId+","+this.examType+","+this.tbGroup+","+this.ruleForm.department)
      if(!this.ruleForm.department){
        // this.$message.error('请填写部门')
        return
      }
      let params = { meetingId : this.meetingId, type : this.examType, tbGroup : this.tbGroup,department: this.ruleForm.department};
      API.findExamId(params).then((data) => {
        if(data.data === 'NULL'){
          this.examName = 'NULL'
          this.examId = 'NULL'
          this.needFillForm = false
        }else{
          this.examId = data.data
          this.findExam(this.examId)
          this.needFillForm = false
        }

      });
    },
    getDepartment(value) {
      this.ruleForm.department = value.value;
      this.showDepartmentPicker = false;
      this.questions=[]
      this.isQuest = false
      this.getExamByDepartment();
    },
    queryHospitalAccordingTokeyword(keyword) {
      // 这里是根据keyword关键字查询接口
      if (!keyword) {
        this.showHospitalPickerByKeyword = false
        this.isEmployee = false
        return
      }else {
        this.isEmployee = false
        API.searchHospitalBykeyword(keyword, this.ruleForm.city).then((data) => {
          this.hospitalListByKeyword = [];
          if (data && data.data.length > 0) {
            // 查到相关的医院，保存接口返回的数组，并打开弹窗
            console.log('data'+ JSON.stringify(data.data))
            data.data.forEach((element) => {
              this.hospitalListByKeyword.push(element.hosName);
            });
            console.info(this.hospitalListByKeyword[0]);
            this.showHospitalPicker = false;
            if (this.hospitalListByKeyword.length == 1 && keyword == this.hospitalListByKeyword[0]) {
              this.showHospitalPickerByKeyword = false;
            } else {
              this.showHospitalPickerByKeyword = true;
            }
          } else {
            // 没有查到相关的医院
          }
        });
      }

    },
    getDepartmentList() {
      API.getDepartmentList().then((data) => {
        if (data && data.data.length > 0) {
          this.departmentList = [];
          data.data.forEach((element) => {
            this.departmentList.push({
              value: element.department,
            });
          });
        }
      });
    },
    init() {
      this.wxInstance();
      console.log('openid:' + this.openid)
      console.log('meetingId:' + this.meetingId)
      console.log('examId:' + this.examId)
      if(this.examId){
        this.findExam(this.examId)
      }
      this.getMeeting(this.meetingId)

    },
    getMeeting(meetingId) {
      API.getMeeting(meetingId).then(result => {
        this.preCoverUrl = result.data.preCoverUrl
        this.behCoverUrl = result.data.behCoverUrl
        this.meetingName = result.data.tbTitle
        document.title = result.data.tbTitle
        this.preRemark = result.data.preRemark
        this.behRemark = result.data.behRemark
      })
    },
    getProvince(value) {
      this.ruleForm.address = value[0].name + "-" + value[1].name;
      this.ruleForm.province = value[0].name;
      this.ruleForm.city = value[1].name;
      this.ruleForm.hospital = "";
      this.ruleForm.remark = "";
      this.hospitalList = [];
      this.hospitalListByKeyword = [];
      this.showProvincePicker = false;
      this.hospitalInputIsShow = true;
      this.hospitalRequired = true;
    },
    getHospital(value) {
      this.ruleForm.hospital = value.value;
      this.showHospitalPicker = false;
    },
    getHospitalByKeyword(value) {
      console.info(value);
      this.ruleForm.remark = value;
      this.showHospitalPickerByKeyword = false;
    },
    wxInstance(){
      // this.$message.error('tbGroup' + this.tbGroup)
      let params = {id: this.meetingId,examType:this.examType, tbGroup: this.tbGroup, department: this.department,signCodeUrl: location.href.split('#')[0]}
      let tbgroup = ''
      if(this.tbGroup){
        tbgroup = this.tbGroup
      }
      let title = '调研';
      if(this.examType === 'pre') {
        title = '会前调研';
      }
      if(this.examType === 'beh') {
        title = '会后调研';
      }
      API.getSignature(params).then(res => {
        wx.config({
          debug: false,
          appId: res.data.appId,
          timestamp: res.data.timestamp,
          nonceStr: res.data.nonceStr,
          signature: res.data.signature,
          jsApiList: ['updateAppMessageShareData']
        });
        wx.ready(function () {
          var shareData = {
            title: title,
            desc: res.data.meetingName + tbgroup,
            link: res.data.url,
            imgUrl: res.data.imgUrl,
            success: function () {
            }
          };
          wx.updateAppMessageShareData(shareData);
        });
      });
    },
    findExam(examId) {
      API.findExam(examId).then(result => {
        API.getCustomerInfo(this.openid).then(result1 => {
          console.info(result1)
          let customerInfo = result1.data
          this.questions = result.data.questionList
          this.questions.forEach( item => {
            this.isQuest = true
            if (item.type == 'RADIO') {
              item.answer = ''
            } else if (item.type == 'CHECKBOX') {
              item.answer = []
            } else if (item.type == 'TEXT' && item.question ==='专家姓名') {
              item.answer = customerInfo.tbName
            } else if (item.type == 'TEXT' && item.question ==='专家医院') {
              item.answer = customerInfo.hosName
            } else if (item.type == 'TEXT' && item.question ==='专家科室') {
              item.answer = customerInfo.department
            }
          })
        })
      })
    },
    valid() {
      let valid = true
      this.questions.forEach( item => {
        if (item.type == 'RADIO' && !item.answer) {
          valid = false
        } else if (item.type == 'CHECKBOX' && !item.answer.length > 0) {
          valid = false
        } else if (item.type == 'TEXT' && !item.answer) {
          valid = false
        }
      })
      return valid
    },
    handleSubmit() {
      if(!this.ruleForm.name){
        this.$message.error('请填写姓名')
        return
      }
      if(!this.ruleForm.phone  && this.isSign == '0'){
        this.$message.error('请填写手机号')
        return
      }
      if(!this.ruleForm.vcode && this.isSign == '0'){
        this.$message.error('请填写验证码')
        return
      }
      if(!this.ruleForm.province){
        this.$message.error('请填写省市')
        return
      }
      if(!this.ruleForm.remark){
        this.$message.error('请填写医院')
        return
      }
      if(!this.ruleForm.department){
        this.$message.error('请选择科室')
        return
      }
      if (this.valid()) {
        let questionList = []
        this.questions.forEach( item => {
          let question = { stockId: item.stockId, answer: item.answer.toString(), otherAnswer: item.otherAnswer || item.reason || item.tools }
          questionList.push(question)
        })
        const openid = this.openid
        const meetingId = this.meetingId
        const examId = this.examId
        const examType = this.examType
        API.saveResult({ meetingId: meetingId, examId: examId, examType: examType, openid: openid, quesList: questionList,
          type : this.examType, tbGroup : this.tbGroup, department: this.ruleForm.department,
          province: this.ruleForm.province,city: this.ruleForm.city,hospital: this.ruleForm.remark,
          tbName: this.ruleForm.name, examMobile: this.ruleForm.phone, vcode : this.ruleForm.vcode
        }).then(data => {
          if (data.success) {
            this.$router.push({
              name: 'submitSuccess',
              query: { openid: openid, meetingId: meetingId, examId: examId, examType: examType }
            });
          } else {
            this.$message.error(data.message)
          }
        })
      } else {
        this.$message.error('还有问题未填写')
      }
    }
  }
}
</script>
<style lang='less' scoped>
.app-container{
  .banner {
    width: 100%;
    height: auto;
  }
  /deep/textarea{
    border:1px solid #ccc;
  }
  .button {
		width: 90%;
		margin: 25px auto;
		border-radius: 6px;
	}
  /deep/.van-cell-group{
    .question{
      font-size: 14px;
      padding: 5px 0;
    }
    .van-radio{
      margin:8px 0;
      font-size: 14px;
    }
    .van-checkbox__label{
    margin:8px;
    font-size: 14px;
    }
    margin:10px 20px;
    padding: 10px;
    border-radius: 5px;
    color: #646566;
  }
  .news-detail {
    height: 100%;
    margin-top: 20px;
    padding-bottom: 10px;
    overflow: auto;
    box-sizing: border-box;
    color: #646566;
    .title {
      font-size: 18px;
      font-weight: bold;
      border-bottom: 1px solid #f7f7f7;
      text-align: center;
    }
    .examType {
      font-size: 16px;
      text-align: center;
      font-weight: bold;
      border-bottom: 1px solid #f7f7f7;
    }
    .content {
      margin: 0 10px;
      font-size: 16px;
    }
  }
  .hospitalListByKeyword {
    width: 100%;
    height: auto;
    margin: 0 auto;
    background-color: #fff;
  }
}
 
</style>
<style lang="less">
.content {
  .van-field__label {
    margin-left: 6px;
  }

  .van-icon__image {
    width: 18px;
    height: 18px;
  }
  .van-radio__label {
    color: #646566;
  }
}
</style>